import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { InfoCircleOutlined } from "@ant-design/icons";
import styles from "./style.module.scss";

/**
 * Shown on a product's pages once its trial or plan has ended: what the customer built stays
 * visible, nothing new can be done until the plan is renewed. ``product`` is "survey" or "engage".
 */
const PlanEndedNotice = ({ product }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.notice} role="status">
      <InfoCircleOutlined className={styles.icon} />
      <div className={styles.body}>
        <div className={styles.title}>{t(`planEnded.${product}_title`)}</div>
        <p className={styles.text}>{t(`planEnded.${product}_body`)}</p>
      </div>
      <Link to="/settings/plan" className={styles.cta}>
        {t("planEnded.renew")}
      </Link>
    </div>
  );
};

export default PlanEndedNotice;
